import { render } from "./AiAssistantWidget.vue?vue&type=template&id=147f38fc&scoped=true"
import script from "./AiAssistantWidget.vue?vue&type=script&lang=js"
export * from "./AiAssistantWidget.vue?vue&type=script&lang=js"

import "./AiAssistantWidget.vue?vue&type=style&index=0&id=147f38fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147f38fc"]])

export default __exports__